const toCurrencyDefault = (value, separator) => {
  return value
    .toFixed(2)
    .toString()
    .replace('.', separator)
}

const toCurrencyChile = (value, separator) => {
  const auxValue = Number.isInteger(value) ? value : value.toFixed()
  return splitWithThreeDigits(auxValue, separator) + '*'
}

function splitWithThreeDigits(value, separator) {
  const parsed = value.toString().split('.')
  const threeDigitSplitterRegex = /\B(?=(\d{3})+(?!\d))/g
  parsed[0] = parsed[0].replace(threeDigitSplitterRegex, '.')

  return parsed.join(separator)
}

const toCurrencyColombia = (value, separator) => {
  return splitWithThreeDigits(value, separator)
}


export const toCurrencyStrategy = (
  value,
  separator,
  strategy = '__default__'
) => {
  const toCurrencyStrategy = {
    es_CO: toCurrencyColombia,
    es_CL: toCurrencyChile,
    __default__: toCurrencyDefault
  }
  return toCurrencyStrategy[strategy]
    ? toCurrencyStrategy[strategy](value, separator)
    : toCurrencyStrategy.__default__(value, separator)
}
